import { NotifyHelper } from "../../../helpers/toast";
import { objDmLoaiLienHeDefine } from "../../action-types/crm-category/IDmLoaiLienHeActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const dmLoaiLienHeActions = {
    ...generateActions(objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE"),
    ...generateActionForKey(objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Lưu thành công")),
    ...generateActionForKey(objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Xóa thành công")),
    ...generateActionForKey(objDmLoaiLienHeDefine, "DM_LOAI_LIEN_HE",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
